import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'ns-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss']
})
export class PageContainerComponent implements OnInit {
  @Input() sidebarHeader: string;

  constructor() { }

  ngOnInit(): void {
  }

}
